<template>
  <div class="withdraw">
    <div class="withdrawTitle">
      <div>
        <span class="arrow-left"></span>
        <span style="color: #53bcf2; font-size: 14px" @click="gaback()"
          >返回</span
        >
      </div>
      <p>申请提现</p>
      <div style="width: 50px"></div>
    </div>
    <div class="textNumber">  
      <p>
        可提现金额
        <span style="color: #000; font-size: 16px; font-weight: 600"
          >￥{{ withdraw_amount }}</span
        >
      </p>
    </div>
    <div style="margin-top: 10px">
      <van-field
        v-model="valueText" 
        is-link
        readonly
        label="提现到账户"
        placeholder="请选择提现账户"
        @click="showPicker = true"
        style="color: #000"
      />
      <van-popup v-model:show="showPicker" round position="bottom">
        <van-picker
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
    </div>
    <div style="margin-top: 10px" class="textNumber1">
      <p>提现金额</p>
      <span @click="withdrawDeposit()" style="color: #53bcf2; font-size: 16px"
        >提现全部</span
      >
    </div>
    <div class="withDrawInput">
      <span>￥</span>
      <div class="input">
        <input
          @input="modifyData()"
          placeholder="请输入提现金额"
          min="100"
          max="49000"
          v-model="moneyNumber"
          type="number"
        />
      </div>
      <div
        @click="countNumber()"
        :class="moneyNumber.length <= 0 ? 'confirm1 delete' : 'confirm1'"
      >
        确认
      </div>
    </div>
    <div class="serviceCharge" style="margin-top: 10px">
      <p>提现手续费</p>
    <span v-if="((parseFloat(serverNumber * 100) / 100) <= 0.8)&&withdraw_fee!=0&&moneyNumber.length>1" style="color: #999"
        >￥0.8</span
      >
      <span v-else style="color: #999"
        >￥{{ ((parseFloat(serverNumber * 100) / 100))}}</span
      >
    </div>
    <div class="serviceCharge" style="margin-top: 10px">
      <p>到账金额</p>
      <span style="font-size: 20px; color: #000; font-weight: 500"
        >￥{{ isNaN(arrival)? 0:Math.floor(arrival * 10000) / 10000 }}</span
      >
    </div>
    <div
      class="serviceCharge"
      style="
        margin-top: 10px;
        padding-bottom: 10px;
        display: block;
        padding-left: 10px;
      "
    >
      <p>提现须知</p>
      <p class="remark" id="remark" style="margin-top: 10px">
      </p>
    </div>
    <div class="confirm">
      <div
        @click="withdraw()"
        :class="
          isButtonActive ? 'confirmButton confirmbutton' : 'confirmButton'
        "
      >
        确认提现
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import VIEW from "@/axios/view";
import API from "@/axios";
import { Toast } from "vant";
import { useRouter } from "vue-router";
const router = useRouter();
let valueText = ref("");
let withdrawId = ref("");
let withdraw_amount = ref("");
let withdraw_fee=ref(0);
// let timer = ref(null);
let serverNumber = ref(0);
let moneyNumber = ref("");
let showPicker = ref(false);
let columns = ref([]);
let arrival = ref(0);
let isConfirm = ref(false);
const isButtonActive = ref(true);

function onConfirm(value) {
  console.log(value);
  valueText.value = value.text;
  withdrawId.value = value.value;
  showPicker.value = false;
  // console.log(withdrawId.value);
}
// // 判断今天是否是4日或19日
// function isButtonAvailable() {
//   const today = new Date();
//   const dayOfMonth = today.getDate(); // 获取当月第几天（1-31）
//   return dayOfMonth === 4 || dayOfMonth === 19;
// }
function getData() {
  VIEW({
    url: "/web/applyWithdraw",
    method: "post",
  }).then((res) => {
    // console.log(res);
    columns.value = objectToArray(
      res.data.data[1].form.field.withdraw_type.value
    );
    withdraw_amount.value = res.data.data[1].form.field.withdraw_amount.value;
    document.querySelector("#remark").innerHTML =res.data.data[2].data.desc;
    withdraw_fee.value= parseFloat(res.data.data[2].data.withdraw_fee);
    // console.log(columns.value);
  });
}
function gaback() {
  window.history.back();
}
function modifyData() {
  // if(moneyNumber.value>=withdraw_amount.value){
  //   moneyNumber.value = withdraw_amount.value;
  // }
  if(moneyNumber.value==0){
    arrival.value=serverNumber.value=0
    isConfirm.value=false
  }
}
function objectToArray(obj) {
  return Object.entries(obj).map(([id, value]) => ({
    text: value,
    value: id,
  }));
}
function countNumber() {
  if (moneyNumber.value.length <= 0) {
    Toast("请输入提现金额");
    return;
  }
    if(moneyNumber.value==0){
    Toast("提现金额不能为0");
    return
  }
    serverNumber.value = (withdraw_fee.value==0?0: ((parseFloat(moneyNumber.value) * (withdraw_fee.value/100))<=0.8)&&withdraw_fee.value!==0)?0.8:(withdraw_fee.value==0?0: (parseFloat(moneyNumber.value) * (withdraw_fee.value/100))).toFixed(2);
  console.log(withdraw_fee.value)
  arrival.value =
    Math.round((parseFloat(moneyNumber.value) - parseFloat(serverNumber.value)).toFixed(2)*10000)/10000;
    isConfirm.value=true
      Toast("提现金额确认成功");
}
function withdrawDeposit() {
  moneyNumber.value = withdraw_amount.value;
  countNumber();
}
function withdraw() {
  if (isButtonActive.value) {
    if (!isConfirm.value) {
      Toast("请确认提现金额");
      return;
    }
    API({
      url: "web/applyWithdraw?source=post",
      method: "post",
      data: {
        amount: moneyNumber.value,
        withdraw_type: withdrawId.value,
      },
    }).then((res) => {
      // console.log(res);
      if (res.data.status == 200) {
        Toast("申请成功");
        router.push({
          name: "event",
          params: { pt: "your_value" }, // 必须提供 pt 参数
          query: { url: encodeURIComponent(res.data.data.url) },
        });
      } else {
        Toast(res.data.msg);
      }
    });
  }
}

onMounted(() => {
  getData();
  // isButtonActive.value = isButtonAvailable();
});
</script>
<style scoped lang="less">
.withdraw {
  background: #ebeaea;
}
.withdrawTitle {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 1px solid #ccc;
}
.withDrawInput {
  width: 100%;
  height: 100px;
  background: #fff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 30px;
  justify-content: space-between;
  .input {
    width: 70%;
    input {
      width: 100%;
    }
  }
}
.textNumber1 {
  display: flex;
  width: 100%;
  height: 80px;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  padding-left: 20px;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
}
.arrow-left {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin-left: 10px;
}
.textNumber {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  padding-left: 20px;
  border-radius: 1px solid #ccc;
}

.arrow-left::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-left: 2px solid black; /* 线条粗细 */
  border-bottom: 2px solid black; /* 线条粗细 */
  transform: rotate(45deg); 
}
/deep/ .van-field__label {
  text-align: left !important;
  width: 180px;
}
.serviceCharge {
  width: 100%;
  background: #fff; 
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 30px;
  padding-top: 40px;
  padding-bottom: 40px;
  align-items: center;
}
.remark {
  font-size: 25px;
  color: #999;
}
.confirm {
  width: 100%;
  height: 130px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 30px;
}
.confirmButton {
  width: 90%;
  height: 100px;
  background: #ccc;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 33px;
}
.confirmbutton {
  background: #0a3beb !important;
}
.confirm1 {
  padding: 20px;
  background: #0a3beb;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
}
.delete {
  background: #ccc !important;
}
</style>
